class TextArea {
  private readonly internaltext: HTMLSpanElement;
  private readonly container: HTMLDivElement;
  private readonly textarea: HTMLTextAreaElement;

  constructor(node: HTMLDivElement) {
    this.textarea = node.querySelector('textarea') as HTMLTextAreaElement;
    this.container = node.parentElement as HTMLDivElement;
    this.internaltext = this.container.querySelector(
      `#char-count-${this.textarea.getAttribute('id')}`
    ) as HTMLSpanElement;
  }

  init(): void {
    if (this.internaltext !== null) {
      this.container.addEventListener('input', () =>
        this.updateCharacterCount(this.textarea, this.internaltext)
      );
    }
  }
  updateCharacterCount(textarea: HTMLTextAreaElement, span?: HTMLSpanElement): void {
    const taMaxLength: string | null = textarea.getAttribute('maxlength');

    if (!span) return;

    if (taMaxLength?.length && parseInt(taMaxLength) > 0) {
      span.textContent = `${textarea.value.length}/${taMaxLength}`;
    } else {
      span.textContent = `${textarea.value.length}`;
    }
  }
}

export function initializeTextareas(): void {
  const textAreasDiv = document.querySelectorAll('.textarea');
  if (!textAreasDiv || textAreasDiv.length === 0) {
    return;
  }

  textAreasDiv.forEach((value) => {
    const textAreaDiv = value as HTMLDivElement;
    const textareaClass = new TextArea(textAreaDiv);
    textareaClass.init();
  });
}

export function resetTextAreaCount(textAreaElement: HTMLTextAreaElement): void {
  const container = textAreaElement.closest('.textarea')?.parentElement;
  if (!container) return;

  const span = container.querySelector(
    `#char-count-${textAreaElement.getAttribute('id')}`
  ) as HTMLSpanElement;

  if (span) {
    const taMaxLength = textAreaElement.getAttribute('maxlength');
    if (taMaxLength?.length && parseInt(taMaxLength) > 0) {
      span.textContent = `0/${taMaxLength}`;
    } else {
      span.textContent = '0';
    }
  }
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initializeTextareas);
} else {
  initializeTextareas();
}
